<template>
    <div class="orderManage-container">
        <el-card  class="mb16">
            <div class="orderManage-query">
                <div class="orderManage-query-input">
                    <div class="query-input-item">
                        <span class="input-item-label"> 订单号:</span>
                        <el-input class="query-input" size="small" placeholder="请输入订单号" v-model="query.order_no" clearable></el-input>
                    </div>
                    <div class="query-input-item">
                        <span class="input-item-label"> 产品:</span>
                        <!-- <el-input class="query-input" size="small" placeholder="请输入订单号" v-model="query.product_code" clearable></el-input> -->
                        <el-select v-model="query.product_code" placeholder="请选择产品" size="mini" clearable class="mr20 query-select-shot">
                            <el-option v-for="item in options.productList" :key="item.id" :label="item.product_name" :value="item.product_code"></el-option>
                        </el-select>
                    </div>     
                    <div class="query-input-item">
                        <span class="input-item-label"> 交易状态:</span>
                        <el-select v-model="query.status" placeholder="请选择交易状态" size="mini" clearable class="mr20 query-select-shot">
                            <el-option label="处理中" value="0"></el-option>
                            <el-option label="处理成功" value="1"></el-option>
                        </el-select>
                    </div>   
                    <div class="query-input-item">
                        <span class="input-item-label"> 核销状态:</span>
                        <el-select v-model="query.card_status" placeholder="请选择核销状态" size="mini" clearable class="mr20 query-select-shot">
                            <el-option label="未核销" value="0"></el-option>
                            <el-option label="已核销" value="1"></el-option>
                            <el-option label="已锁定" value="2"></el-option>
                        </el-select>
                    </div>       
                    <div class="query-input-item">
                        <span class="input-item-label"> 提卡时间:</span>
                        <el-date-picker class="query-date" size="small" v-model="query.orderDate" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                    </div>                     
                </div>
                <div class="orderManage-query-btn orderManage-query-input">
                   
                    <div class="query-input-item">
                        <span class="input-item-label"> 商户单号:</span>
                        <el-input class="query-input" size="small" placeholder="请输入商户单号" v-model="query.business_order_no" clearable></el-input>
                    </div> 
                    <div class="query-input-item">
                        <span class="input-item-label"> 系统单号:</span>
                        <el-input class="query-input" size="small" placeholder="请输入系统单号" v-model="query.system_order_no" clearable></el-input>
                    </div>               
                </div>
                <div class="orderManage-query-input  query-input-between">
                    <div class="flexX flexStart flexcenter">                    
                        <div class="query-input-item">
                            <span class="input-item-label"> 面值:</span>
                            <el-select v-model="query.face_value" placeholder="请选择面值" clearable size="mini" class="mr20">
                                <el-option v-for="item in options.faceValueList" :key="item.id" :label=" item.label " :value="item.value"></el-option>                            
                            </el-select>
                        </div>
                        <div class="query-input-item">
                            <span class="input-item-label"> 提卡类型:</span>
                            <el-select v-model="query.order_type" placeholder="请选择面值" clearable size="mini" class="mr20">
                                <el-option v-for="item in options.orderTypeList" :key="item.id" :label=" item.label " :value="item.value"></el-option>                            
                            </el-select>
                        </div>
                        
                        <div class="query-input-item">
                            <span class="input-item-label"> 卡号:</span>
                            <el-input type="textarea" :rows="3" class="query-input-area" size="small" placeholder="请输入卡号，多个卡号请换行分隔" v-model="query.card_number"></el-input>
                        </div> 
                    </div>    
                    <div class="query-input-item">
                        <el-button class="query-btn" type="primary" size="small" :disabled="query.loading" @click = "getData">查询</el-button>
                        <el-button class="query-btn cancel" plain size="small" :disabled="query.loading" @click="reset">重置</el-button>
                    </div> 
                </div>
                <!-- <div class="orderManage-query-input query-input-between">   
                      
                    <div class="query-input-item">
                        <el-button class="query-btn" type="primary" size="small" :disabled="query.loading" @click = "getData">查询</el-button>
                        <el-button class="query-btn cancel" plain size="small" :disabled="query.loading" @click="reset">重置</el-button>
                    </div>
                </div>                -->
            </div>
        </el-card>
        <el-card>
            <div class="orderManage-table-div">
                <div class="table-toolbar">
                    <div class="toolbar-left">
                        <el-button type="warning" size="small" :disabled="table.lockArr.length == 0 || query.loading" @click="lockCard">锁卡({{table.lockArr.length}})</el-button>
                        <!-- <el-button type="success" size="small" :disabled="table.unlockArr.length == 0 || query.loading" @click="unlockCard">解锁({{table.unlockArr.length}})</el-button> -->
                    </div>
                    <div class="toolbar-right">                        
                        <el-button type="plan" icon="el-icon-refresh" size="small" @click="allList">刷新</el-button>
                    </div>
                </div>
                <el-table ref="multipleTable" class="table-class" @selection-change="handleSelectionChange" :data="table.tableData" style="width: 100%;" border header-row-class-name="header-row-class-name" header-cell-class-name="header-class-name" cell-class-name="cell-class-name">
                    <el-table-column type="selection" width="55" :selectable="checkSelectable"></el-table-column>
                    <el-table-column prop="water_no" label="订单号" min-width="190px">
                        <template scope="scope">
                            <div class="cprimary" v-if="scope.row.order_type == 1">{{scope.row.business_order_no}}</div>
                            <div class="csuccess fs12">{{scope.row.order_no}}</div>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column prop="" label="商户信息" min-width="165px">
                        <template scope="scope">
                            <div class="c303133">{{scope.row.trader_id}}</div>
                            <div class="c909399">{{scope.row.trader_username}}</div>
                        </template>
                    </el-table-column> -->
                    <el-table-column prop="" label="产品"  width="180px">
                        <template scope="scope">
                            <div>
                                <span>{{scope.row.product_name}}</span>
                                <span v-if="scope.row.product_name && scope.row.face_value">-</span>
                                <span v-if="scope.row.face_value">[</span>
                                <span>{{scope.row.face_value}}</span>
                                <span v-if="scope.row.face_value">]</span>
                            </div>
                        
                        </template>
                    </el-table-column>
                    <el-table-column prop="" label="卡密信息" width="187px" >
                        <template scope="scope">
                            <div class="c303133">{{scope.row.card_number}}</div>
                            <div class="c909399">********{{scope.row.card_password.substring(scope.row.card_password.length - 4,scope.row.card_password.length)}}</div>
                          
                        
                        </template>
                    </el-table-column>
                    <el-table-column prop="face_value" label="交易金额" >
                        <template slot-scope="scope"> 
                            <div>¥{{scope.row.face_value}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="quantity" label="交易数量" ></el-table-column>
                    <el-table-column prop="order_type_text" label="提卡类型" width="150px">
                        <template slot-scope="scope">
                            <div class="">
                                <el-tag :type="scope.row.order_type == '1'?'success':scope.row.order_type == '2'? 'primary':'info'" size="mini">{{scope.row.order_type_text}}</el-tag>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="balance" label="交易状态" >
                        <template slot-scope="scope">
                            <div class="nowrap textCenter">
                                <el-tag :type="scope.row.status == '1'?'success':scope.row.status == '0'? 'warning': scope.row.status == '7'?'danger':'info'" size="mini">{{scope.row.status_text}}</el-tag>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="create_time" label="提卡时间" min-width="200px"></el-table-column> 
                    <el-table-column prop="balance" label="核销状态" >
                        <template slot-scope="scope">
                            <div class="nowrap textCenter">
                                <el-tag :type="scope.row.card_status == '1'?'success':scope.row.card_status == '0'? 'warning': scope.row.card_status == '2'?'danger':'info'" size="mini">{{scope.row.card_status_text}}</el-tag>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="" label="核销时间" min-width="200px">
                        <template slot-scope="scope">
                            <div class="nowrap">
                            <div><span>{{scope.row.update_time?scope.row.update_time:'无'}}</span></div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="锁卡开关" fixed="right">
                        <template slot-scope="scope">
                            <div class="nowrap textCenter">
                                <el-switch :disabled="scope.row.card_status == 1 || scope.row.card_status==2 || query.loading" v-model="scope.row.lockBoolean" @change="lockToggle(scope.row)"></el-switch>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="flexX pageBox flexEnd">
                    <el-pagination :disabled="query.loading" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="query.page" :page-sizes="query.pageSizesArr"
                        :page-size="query.pageSize" layout="total, sizes, prev, pager, next" :total="query.total"></el-pagination>
                </div>
            </div>
        </el-card>
       
    </div>
</template>

<script>
    import {
		Message
	} from 'element-ui'
    export default {
        data() {
            return{
                query:{
                    loading:false,
                    order_no:'',
                    trader_id:'',
                    business_order_no:'',
                    system_order_no:'',
                    trader_name:'',
                    card_number:'',                  
                    product_code:'',
                    face_value:'',
                    order_type:'',
                    status:'',
                    card_status:'',                  
                    orderDate:[],//提卡日期
                    page:0,
                    pageSizesArr:[10,50,200,500],
                    total:0,
                    pageSize: 10,
                },
                options:{
                    productList:[],
                    faceValueList:[],
                    orderTypeList:[],//提卡类型
                },
                table:{
                    tableData:[],
                    height:'200px',
                    lockArr:[],
                    unlockArr:[],
                },               
            }
        },
        created() {
			this.query.orderDate = [];
            this.allList();
            this.getFaceValueList();
            this.getProductList();
            this.getOrderTypeList();
		},
        methods: {
            // 面值列表
            getFaceValueList(){
                this.$api.getFaceValueList({}).then(res=>{
                    if(res.status == 1){
                        this.options.faceValueList = res.data
                    }else{
                        Message.error(res.msg)
                    }
                })
            },
            //产品列表
            getProductList(){
                this.$api.getProductList({}).then(res=>{
                    if(res.status == 1){
                        this.options.productList = res.data
                    }else{
                        Message.error(res.msg)
                    }
                })
            },
            //获取提卡类型列表
            getOrderTypeList(){
                this.$api.getOrderTypeList({}).then(res=>{
                    if(res.status == 1){
                        this.options.orderTypeList = res.data
                    }else{
                        Message.error(res.msg)
                    }
                })
            },
          
            //查询按钮触发
            getData(){
                this.query.page = 1;
                this.query.total = 0;
                this.allList()
            },
            // 分页查询数据
            handleSizeChange(val){
                this.query.pageSize = val;
                this.query.page = 1
                this.query.total = 0
                this.allList()
            },
            handleCurrentChange(val){
                this.query.page = val
                this.allList()
            },
            // 订单列表查询接口
            allList(){
                let data ={
                    "order_no": this.query.order_no,//  筛选项 订单编号
                    "product_code":this.query.product_code,//产品
                    "face_value":this.query.face_value,//面值
                    "business_order_no":this.query.business_order_no,
                    "system_order_no":this.query.system_order_no,//系统订单编号
                    "card_number":this.query.card_number,//卡号
                    "status":this.query.status,//交易状态
                    "order_type":this.query.order_type,//取卡类型
                    "card_status": this.query.card_status,//  筛选项 核销状态
                    "startTime": this.query.orderDate.length == 2 ? this.$util.timestampToTime(Date.parse(new Date(this.query.orderDate[0])), false) : '', // 下单开始时间
                    "endTime":this.query.orderDate.length == 2 ? this.$util.timestampToTime(Date.parse(new Date(this.query.orderDate[1])), false) : '', // 下单结束时间
                    "size": this.query.pageSize,
                    "page": this.query.page,
                }
                this.query.loading = true;
                this.$api.cardOrderAllList(data).then(res=>{
                    this.query.loading = false;
                    if(res.status == 1){
                        res.data.data.forEach(item=>{
                            item.lockBoolean = item.lock_switch == 1?true:false
                            return item
                        })
                        this.table.tableData = res.data.data
                        this.query.total = res.data.total
                    }else{
                        Message({
                            message: res.msg,
                            type: 'error',
                            duration: 3 * 1000
                        });
                    }
                }).catch(e=>{
                    this.query.loading = false;
                })
            },
            // 重置查询条件
            reset(){
                this.query.orderDate = [];
                this.query.order_no=""
                this.query.product_code=""
                this.query.face_value=""
                this.query.trader_id=""
                this.query.business_order_no=""
                this.query.system_order_no=""
                this.query.trader_name=""
                this.query.card_number=""
                this.query.status=""
                this.query.card_status=""
                this.query.page = 1
                this.getData()
            },
            //设置某项不可选
            checkSelectable(row){
                let selectable = row.card_status == 1 ? false : true
                return selectable;
            },
            //列表选择事件
            handleSelectionChange(val){
                let selected = val;
                let unlock = selected.filter(item=>{ 
                    //已锁定 将要解锁
                    return item.card_status==2
                })
                let lock = selected.filter(item=>{
                    //未锁定 将要锁卡
                    return item.card_status == 0
                })
                this.table.lockArr = lock
                this.table.unlockArr = unlock
            },           
            // 解锁接口
            unlockCardApi(data){ 
                this.query.loading = true;
                this.$api.unlockCard(data).then(res=>{                     
                    this.query.loading = false;
                    if(res.status == 1){                            
                        this.allList();
                        this.$refs.multipleTable.clearSelection();
                        this.table.unlockArr = [];
                        Message({
                            message: res.msg,
                            type: 'success',
                            duration: 3 * 1000
                        });
                    }else{
                        Message({
                            message: res.msg,
                            type: 'error',
                            duration: 3 * 1000
                        });
                    }
                }).catch(e=>{
                    this.query.loading = false;
                })
            },
             // 锁定接口
             lockCardApi(data){                
                this.query.loading = true;
                this.$api.lockCard(data).then(res=>{                     
                    this.query.loading = false;
                    if(res.status == 1){
                        this.allList();
                        this.$refs.multipleTable.clearSelection();
                        this.table.lockArr = [];
                        Message({
                            message: res.msg,
                            type: 'success',
                            duration: 3 * 1000
                        });
                    }else{
                        Message({
                            message: res.msg,
                            type: 'error',
                            duration: 3 * 1000
                        });
                    }
                }).catch(e=>{
                    this.query.loading = false;
                })
            },
            
            //锁卡开关
            lockToggle(row){
                let data ={
                    "ids":row.id
                }
                if(row.lock_switch == 1){
                    //已锁定 将要解锁
                    this.unlockCardApi(data)
                }else{
                    this.lockCardApi(data)
                }
               
            },
            //解锁
            unlockCard(){
                this.$confirm(`确定要解锁选中的 ${this.table.unlockArr.length} 张卡吗？`, '批量解锁确认', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let ids = this.table.unlockArr.map(item=>item.id)
                    let data ={ 
                        "ids":ids.join(',')
                    }
                    this.unlockCardApi(data)
                }).catch(() => {
                });
            },
            // 锁定
            lockCard(){ 
                this.$confirm(`确定要锁定选中的 ${this.table.lockArr.length} 张卡吗？`, '批量锁卡确认', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {                   
                    let ids = this.table.lockArr.map(item=>item.id)
                    let data ={ 
                        "ids":ids.join(',')
                    }
                    this.lockCardApi(data)
                }).catch(() => {
                });
            },
           
        }
    }
</script>

<style lang="scss">
    @import "@/style/tablestyle.scss";
    
	// @import '@/style/variables.scss';
</style>
<style lang="scss" scoped>
.orderManage-container{
    padding-top: 10px;
    padding-right: 10px;
    .orderManage-query{
        padding-left:10px;       
        .orderManage-query-input{
            display:flex;
            justify-content: flex-start;
            align-items:center;
            flex-wrap: wrap;
            &.query-input-between{
                justify-content: space-between;
            }
            .query-input-item{
                margin-bottom: 16px;
                margin-right:25px;
                display:flex;
                font-size:14px;
                align-items:center;
                .input-item-label{
                    white-space: nowrap;
                    margin-right: 10px;
                    color: #606266;
                }
                .query-select-shot{
                    width: 126px;
                }
                .query-date{
                    width: 340px;
                }
                .query-input{
                    width: 200px;
                    margin-left: 20px;
                }
                .query-input-area{
                    width: 300px;
                }
                
            }
        }
        .orderManage-query-btn{
            .query-btn{
                width: 80px;
                height: 30px;
            }
        }
    }
    .orderManage-table-div{
        // margin-top:41px;
        .table-toolbar{
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 16px;
            padding: 16px;
            background: #fff;
            border-bottom: 1px solid #ebeef5;
        }
        .pageBox{
            padding: 16px 20px;
            border-top: 1px solid #ebeef5;
            background-color: #fafcff;

        }
    }
  
}
</style>